import React from "react";
import classnames from "classnames";
import { Button, Card } from "components/UI";
import { bgCommunity } from "assets";
import { useNavigate } from "react-router-dom";
import { isProduction } from "utils/config";
import { BackgroundSection } from "../common";
import useCheckSignupPause from "hooks/useCheckSignupPause";

const VIDEO_URL = isProduction
  ? "https://www.youtube.com/embed/fFOH8VcERMo?autoplay=1&mute=1&playsinline=1"
  : "https://www.youtube.com/embed/fFOH8VcERMo?autoplay=1&mute=1&playsinline=1";

const HeroSection = () => {
  const navigate = useNavigate();
  const isPauseSignup = useCheckSignupPause();
  return (
    <div className="mt-24 md:mt-40">
      <BackgroundSection
        backgroundImage={`url(${bgCommunity.default})`}
        minHeight="640px"
        className="min-h-screen bg-no-repeat bg-cover xl:bg-full bg-center pt-10 px-4 sm:mb-10 md:-mb-16"
      >
        <div className="flex justify-center max-w-6xl mx-auto px-4 md:px-8">
          <div className="flex flex-col items-center justify-center">
          <div className="lg:col-span-3 mb-8 sm:m-0 relative rounded overflow-hidden">
              <iframe
                height="400"
                width="700"
                className="mx-auto lg:m-0"
                src={VIDEO_URL}
                title="landingVideo"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
            <Card
              className={classnames(
                "flex flex-col items-center justify-center text-center",
                "py-4 sm:py-12 px-4 sm:px-4 lg:py-8 sm:mx-12 sm:-mt-8 lg:mx-0 lg:my-12 lg:col-span-2",
                "rounded lg:rounded-l-none lg:rounded-tr",
              )}
            >
              {/* <h4>WHAT IS GIG LIFE PRO?</h4> */}
              <div className="w-full max-w-3xl mx-auto font-normal text-center space-y-5 leading-relaxed">
                <p>GIG LIFE PRO CREATES REAL INDUSTRY ACCESS ACROSS ASIA-PACIFIC AND BEYOND, CONNECTING ARTISTS, TEAMS AND PARTNERS WITH SUCCESSFUL PEOPLE IN THE RIGHT MARKETS - EMPOWERING THEM WITH LOCAL MARKET AND BROADER INDUSTRY INFORMATION TO GUIDE THEIR GROWTH.</p>
                <p>WE ARE A COMMUNITY OF PEOPLE WHO ARE GROWING THE MUSIC BUSINESS THROUGH SHARED EXPERIENCE AND VALUABLE OPPORTUNITIES - PROVIDING A STAGE FOR PEOPLE WHO HAVE RUN SUCCESSFUL CAMPAIGNS TO INFORM AND INSPIRE US ALL.</p>
                  {/* <p>
                    Our <strong>Gig Life Pro Members Community</strong> is a{" "}
                    <strong>curated network of over 2000 Global Members</strong>, across{" "}
                    <strong>60 Cities Globally</strong>, representing over{" "}
                    <strong>50 Roles in the Industry</strong> and with an{" "}
                    <strong>average of 12+ yrs of Experience.</strong>
                  </p>
                  <div>
                    <p className="mb-2 font-medium">GLP Members receive:</p>
                    <ul className="list-none space-y-1.5 m-0 p-0">
                      <li>– Priority invitations</li>
                      <li>– Curated introductions</li>
                      <li>– Partnership opportunities</li>
                      <li>– Direct access to our global network</li>
                    </ul>
                  </div>
                  <p className="sm:mb-0">
                    Gig Life Pro focuses on creating{" "}
                    <strong>real industry access across Asia-Pacific and beyond</strong>,{" "}
                    <strong>connecting artists, teams, and partners</strong> with{" "}
                    <strong>successful people</strong> in the <strong>right markets</strong> and{" "}
                    <strong>empowering them</strong> with <strong>local market</strong> and{" "}
                    <strong>broader industry information</strong> to <strong>guide</strong> their{" "}
                    <strong>growth.</strong>
                  </p> */}
              </div>
              {!isPauseSignup && <div className="mt-4 lg:mt-4">
                <Button
                  label="Submit Your Application"
                  onClick={() => navigate("/signup")}
                  className="py-2 lg:py-4"
                />
              </div>}
            </Card>
          </div>
        </div>
      </BackgroundSection>
    </div>
  );
};

export default HeroSection;
